import { useTranslation } from 'react-i18next'
import { Info } from 'lucide-react'
import type { UnderenhetMatch } from './api'

/** Why a bedriftsnummer search shows another number: the backend matched
 *  the underenhet's hovedenhet (#1008). Renders nothing for other searches. */
export default function UnderenhetMatchNotice({ match }: { match: UnderenhetMatch | null }) {
  const { t } = useTranslation('leads')
  if (!match) return null
  return (
    <div
      data-testid="underenhet-match"
      className="mb-4 flex items-center gap-2 rounded-md border border-primary-200 bg-primary-50 px-3 py-2 text-sm text-primary-800 dark:border-primary-800 dark:bg-primary-900/20 dark:text-primary-200"
    >
      <Info className="w-4 h-4 shrink-0" aria-hidden="true" />
      <span>{t('underenhetMatch.text', { bedriftsnummer: match.bedriftsnummer, navn: match.navn })}</span>
    </div>
  )
}
